export default __webpack_public_path__ + "static/media/verification.32187783.png";